export default __webpack_public_path__ + "static/media/018-instagram-sketched.30b397e6.svg";